import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

interface IWrapperProps {
  noMembers: boolean;
}

export const Wrapper = styled.div`
  background-color: #fff;
  padding: 10px 20px;
  border-radius: 8px;
  margin: 5px 0;
  display: flex;
  flex-direction: column;
  box-shadow: rgb(220, 220, 220) 0px 0px 15px;
  height: 470px;
  overflow: hidden;
  position: relative;
  justify-content: ${(props: IWrapperProps) => props.noMembers && "center"};
  align-items: ${(props: IWrapperProps) => props.noMembers && "center"};
  color: ${(props: IWrapperProps) => props.noMembers && "#818181"};

  ${mediaMaxWidth.smallDesktop} {
    top: 10px;
  }

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 20px);
    margin: 5px auto;
  }
`;

export const PaginationButtons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 180px;
  margin: 0 auto;
  font-size: 1em;
  position: absolute;
  bottom: 15px;
  left: 0;
  right: 0;

  svg {
    font-size: 1.2em;
    margin: 0 5px;
  }
`;

export const PrevButtonWrapper = styled.div`
  width: 70px;
  display: flex;
  justify-content: center;
  height: 25px;
`;

export const PrevButton = styled.div`
  cursor: pointer;
  height: 25px;
  display: flex;
  align-items: center;

  &:hover {
    color: #79D9D9;
  }
`;

export const NextButtonWrapper = styled.div`
  width: 70px;
  display: flex;
  justify-content: center;
  height: 25px;
`;

export const NextButton = styled.div`
  cursor: pointer;
  height: 25px;
  display: flex;
  align-items: center;

  &:hover {
    color: #79D9D9;
  }
`;
